import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    typeList: () => {
        return HTTP.get('/stock/setting/all-material-type', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addType: (data) => {
        return HTTP.post('/stock/setting/create-material-type',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editType: (id,data) => {
        return HTTP.post(`/stock/setting/update-material-type/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailType: (id) => {
        return HTTP.get(`/stock/setting/edit-material-type/${id}`, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}